class KohlerCorporateConfig {
    constructor(configData) {
        this._rawConfig = configData;
    }

    get facetedSearchEndpointUrl() {
        return this._rawConfig.endpoints.facetedSearchEndpoint;
    }

    get globalSearchEndpointUrl() {
        return this._rawConfig.endpoints.globalSearchEndpoint;
    }

    get careersSearchEndpointUrl() {
        return this._rawConfig.endpoints.careersSearchEndpoint;
    }

    get calendarIcsEndpointUrl() {
        return this._rawConfig.endpoints.calendarIcsEndpoint;
    }

    get downloadUrl() {
        return this._rawConfig.endpoints.downloadUrl;
    }

    get autocompleteUrl() {
        return this._rawConfig.endpoints.autocompleteUrl;
    }

    get formActionUrl() {
        return this._rawConfig.endpoints.formActionUrl;
    }

    get globalSearchPlaceholderText() {
        return this._rawConfig.globalSearchPlaceholderText;
    }

    get socialLinks() {
        return this._rawConfig.socialLinks;
    }

    get fragmentRedirects() {
        return this._rawConfig.fragmentRedirects;
    }

    get asyncScripts() {
        return this._rawConfig.asyncScripts;
    }
}

// save a reference to the config, and remove it from the window object
const configData = window.KohlerConfig;
// TODO: uncomment for prod
// delete window.KohlerConfig;

// export singleton
export default new KohlerCorporateConfig(configData);
